module.exports = __webpack_public_path__ + "static/sf.6415abc7.png";